"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const defaultScene_1 = __importDefault(require("./defaultScene"));
function defaultChapter() {
    return {
        id: null,
        audio: null,
        audioEngine: undefined,
        chapterDuration: '00:05',
        chapterId: null,
        chapterName: 'New Chapter',
        colorHistory: [],
        companyId: null,
        connectionId: null,
        createdAt: Date.now(),
        dataPoints: [],
        defaultValues: {},
        dynamicLabels: [],
        height: 1080,
        highPrecision: false,
        isDynamic: false,
        scenes: [(0, defaultScene_1.default)()],
        sceneTransitions: [],
        user_id: null,
        voiceOverConfig: null,
        width: 1920,
    };
}
exports.default = defaultChapter;
